import { View } from 'react-native';
import { Placeholder, PlaceholderLine, PlaceholderMedia, Shine } from 'rn-placeholder';
import { Card, ScrollView, Stack, XStack } from 'tamagui';

export function CropsHomePlaceHolder() {
  return (
    <>
      <View>
        <Stack marginTop={10} marginLeft={10}>
          <PlaceholderLine width={40} height={15} />
          <PlaceholderLine width={80} height={15} />
        </Stack>
        <Stack
          paddingHorizontal={10}
          paddingBottom={10}
          width={115}
          display="flex"
          flexDirection="row"
        >
          <Placeholder Animation={Shine}>
            <PlaceholderMedia style={[{ width: 75, height: 100, marginTop: 5 }]} />
          </Placeholder>
          <Placeholder Animation={Shine}>
            <PlaceholderMedia style={[{ width: 75, height: 100, marginTop: 5 }]} />
          </Placeholder>
          <Placeholder Animation={Shine}>
            <PlaceholderMedia style={[{ width: 75, height: 100, marginTop: 5 }]} />
          </Placeholder>
          <Placeholder Animation={Shine}>
            <PlaceholderMedia style={[{ width: 75, height: 100, marginTop: 5 }]} />
          </Placeholder>
        </Stack>
      </View>
    </>
  );
}
